<template>
  <a-card :class="computedStatus" class="ant-card-small-body">
    <a-page-header style="padding: 0px">
      <template #title>
        {{ device.name }}
      </template>
      <template #subTitle>
        ostatnio aktywne {{
          isToday(new Date(device.lastSeen)) ? 'dzisiaj' : new Date(device.lastSeen) |
              moment('from', 'now')
        }}
      </template>
      <template slot="tags">
        <a-tag v-if="device.enabled" color="green">
          Aktywne
        </a-tag>
        <a-tag v-else color="red">
          Nieaktywne
        </a-tag>
        <a-tag v-if="computedSession && computedSession.macAddress === device.macAddress"
               color="purple">
          To urządzenie
        </a-tag>
      </template>
      <a-descriptions :column="{ xxl: 3, xl: 1, lg: 2, md: 1, sm: 1, xs: 1 }" size="small">
        <a-descriptions-item label="Lokalizacja">
          {{ device.activeLease ? device.activeLease.dorm.name : '- brak -' }}
        </a-descriptions-item>
        <a-descriptions-item v-if="debugMode" label="Adres urządzenia">
          {{ device.activeLease ? device.activeLease.ip : '- brak -' }}
        </a-descriptions-item>
        <a-descriptions-item label="Utworzono">
          {{ new Date(device.created) | moment("from", "now") }}
        </a-descriptions-item>
        <a-descriptions-item v-if="debugMode" label="Adres MAC">
          {{ device.macAddress }}
        </a-descriptions-item>
      </a-descriptions>
      <a-row :gutter="[8, 8]" style="margin-top: 0px;">
        <a-col :span="24">
          <a-alert v-if="computedStatus === 'device-problem'"
                   message="To urządzenie znajduje się w innym budynku. Możesz je przenieść używając przycisku poniżej."
                   show-icon type="warning"/>
        </a-col>
      </a-row>
      <a-row justify="space-between" style="width: 100%;" type="flex">
        <a-col :span="24" style="text-align: right;">
          <!--                    <a-dropdown v-if="device.enabled" style="margin-left: 8px; margin-top: 8px">-->
          <!--                        <a-menu slot="overlay" @click="handleMenuClick">-->
          <!--                            <a-menu-item key="edit">-->
          <!--                                <a-icon type="edit" /> Zmień nazwę-->
          <!--                            </a-menu-item>-->
          <!--                            <a-menu-item key="report">-->
          <!--                                <a-icon type="warning" /> Zgłoś problem-->
          <!--                            </a-menu-item>-->
          <!--                            <a-menu-divider />-->
          <!--                        </a-menu>-->
          <!--                        <a-button> <a-icon type="setting" /> </a-button>-->
          <!--                    </a-dropdown>-->
          <a-button v-if="device.enabled" key="2" :disabled="device.activeLease.dorm.code === computedSession.dorm.code" style="margin-left: 8px; margin-top: 8px"
                    type="primary" @click="moveDevice">
            <a-icon
                :type="device.activeLease.dorm.code === computedSession.dorm.code ? 'check-circle' : 'login'"/>
            {{ device.activeLease.dorm.code === computedSession.dorm.code ? 'Aktualnie w' : 'Przenieś do' }} {{
              computedSession.dorm.name
            }}
          </a-button>
          <a-button v-if="!device.enabled" key="1" style="margin-left: 8px; margin-top: 8px" type="primary" @click="activateDevice">
            <a-icon type="login"/>
            Aktywuj w {{ computedSession.dorm.name }}
          </a-button>
        </a-col>
      </a-row>
    </a-page-header>
  </a-card>
</template>

<script>
import httpClient from "@/utils/httpClient";

export default {
  name: "Device",
  props: {
    device: Object,
    debugMode: Boolean
  },
  computed: {
    computedSession: function () {
      return this.$store.getters.getUserConnectionDetails;
    },
    computedStatus: function () {
      if (!this.device.activeLease) {
        return "device-offline";
      } else {
        if (this.device.activeLease.dorm.code === this.computedSession.dorm.code) {
          if (this.device.enabled) {
            return "device-online";
          } else {
            return "device-offline";
          }
        } else {
          return "device-problem";
        }
      }
    }
  },
  methods: {
    isToday(date) {
      const today = new Date();
      return date.getDate() === today.getDate() &&
          date.getMonth() === today.getMonth() &&
          date.getFullYear() === today.getFullYear();
    },

    activateDevice() {
      this.$message.loading({content: `Aktywowanie urządzenia ${this.device.name}...`, key: 'activation'});
      httpClient
          .put(`/devices/${this.device.deviceUuid}/activate`)
          .then(() => {
            this.$message.success({content: `Urządzenie ${this.device.name} zostało aktywowane!`, key: 'activation'});
            this.unplugDeviceNotification();
            this.$emit("updated");
          }).catch(() => {
        this.$message.error({content: `Wystąpił błąd z aktywacją ${this.device.name}!`, key: 'activation'});
      })
    },

    moveDevice() {
      this.$message.loading({content: `Przenoszenie urządzenia ${this.device.name}...`, key: 'activation'});
      httpClient
          .put(`/devices/${this.device.deviceUuid}/move`)
          .then(() => {
            this.$message.success({content: `Urządzenie ${this.device.name} zostało przeniesione!`, key: 'activation'});
            this.unplugDeviceNotification();
            this.$emit("updated");
          }).catch(() => {
        this.$message.error({content: `Wystąpił błąd z przeniesieniem ${this.device.name}!`, key: 'activation'});
      })
    },

    unplugDeviceNotification() {
      this.$info({
        title: 'Odłącz kabel na 1 minutę!',
        content: 'Odłącz kabel ethernet w modyfikowanym urządzeniu na 1 minutę i podłącz ponownie aby zmiany zostały zastosowane. Jeśli nie działa to spróbuj ponownie za 15 minut.',
        okText: 'Rozumiem',
        closeText: '',
      });

    }
  }
}
</script>

<style>
.ant-card-small-body .ant-card-body {
  padding: 16px 24px;
}

.ant-card-small-body:hover {
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.1);
}

.badge-fixed-position .ant-badge-status-dot {
  margin-bottom: 5px;
}

.device-online {
  background: linear-gradient(135deg, rgba(82, 196, 26, 0.75) 0%, rgba(82, 196, 26, 0.75) 1.5%, rgba(0, 0, 0, 0) 1.501%);
}

.device-offline {
  background: linear-gradient(135deg, rgba(245, 34, 45, 0.75) 0%, rgba(245, 34, 45, 0.75) 1.5%, rgba(0, 0, 0, 0) 1.501%);
}

.device-problem {
  background: linear-gradient(135deg, rgba(250, 140, 22, 0.75) 0%, rgba(250, 140, 22, 0.75) 1.5%, rgba(0, 0, 0, 0) 1.501%);
}
</style>
